import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cms-message",
  "use": "icon-cms-message-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-cms-message\"><path d=\"M176.66,169.8H43.34a14.52,14.52,0,0,1-14.5-14.5V64.7a14.52,14.52,0,0,1,14.5-14.5H176.66a14.52,14.52,0,0,1,14.5,14.5v90.6A14.52,14.52,0,0,1,176.66,169.8ZM43.34,59.2a5.51,5.51,0,0,0-5.5,5.5v90.6a5.51,5.51,0,0,0,5.5,5.5H176.66a5.51,5.51,0,0,0,5.5-5.5V64.7a5.51,5.51,0,0,0-5.5-5.5Z\" /><polygon points=\"110 123.9 33.45 81.64 37.8 73.76 110 113.62 182.2 73.76 186.55 81.64 110 123.9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol